import { render, staticRenderFns } from "./RatingDisplay.vue?vue&type=template&id=537bdcce&"
import script from "./RatingDisplay.vue?vue&type=script&lang=js&"
export * from "./RatingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537bdcce')) {
      api.createRecord('537bdcce', component.options)
    } else {
      api.reload('537bdcce', component.options)
    }
    module.hot.accept("./RatingDisplay.vue?vue&type=template&id=537bdcce&", function () {
      api.rerender('537bdcce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29EgEWqTIn6Oz/JS/comp/RatingDisplay.vue"
export default component.exports